export default __webpack_public_path__ + "static/media/cross.7f563c71.svg";